import type { DisciplineScheduleFlow, DisciplineScheduleStep } from './enums'

import { useDisciplineScheduleStore } from './schedule/store'
import { useDisciplineScheduleEvents } from './discipline-schedule-events.hook'

interface DisciplineScheduleModalsReturn {
  refFlow: ComputedRef<DisciplineScheduleFlow | null>
  refStep: ComputedRef<DisciplineScheduleStep | null>
}

/** One wizard modal at a time, as in legacy. The page listens for the tutor search before any search starts. */
export const useDisciplineScheduleModals = (): DisciplineScheduleModalsReturn => {
  const store = useDisciplineScheduleStore()

  useDisciplineScheduleEvents()

  onBeforeUnmount(() => {
    store.closeFlow()
  })

  return {
    refFlow: computed<DisciplineScheduleFlow | null>(() => store.getFlow),
    refStep: computed<DisciplineScheduleStep | null>(() => store.getStep),
  }
}
